import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/卡修斯";
import { Soulmark } from "../../core/soulmark";

export class 卡修斯 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(798, "卡修斯", type.地面·暗影, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark([
            "战斗开始时，卡修斯进入诅咒之子状态，为地面·暗影系双属性精灵。",
            "当卡修斯的属性切换为地面系时（或剥离自身的暗影系时），卡修斯激活山神守护Buff，融入黑暗Buff随即失效。期间受到的任何伤害减少90%，免疫异常状态。",
            "当卡修斯的属性切换为暗影系时（或剥离自身的地面系时），卡修斯激活融入黑暗Buff。期间若卡修斯先出手，则当回合对手的技能无效。山神守护Buff随即失效。",
        ]);
        this.技能组 = [
            skill.炫·灭影绝壑,
            skill.炫·乾坤绝弑,
            skill.炫·万山绝影,
            skill.炫彩·九幽劫,
            skill.炫彩·山河烬,
        ];
    }
}